import { INavLink } from "@fluentui/react";
import { AppRoutes } from "./app-routes";

export const AppLinks: INavLink[] = [
  /*
    {
      name: 'System Administration',
      url: AppRoutes.claimsBroker_List.url(),
      key: AppRoutes.claimsBroker_List.key,
      expandAriaLabel: 'Expand Admin section',
      collapseAriaLabel: 'Collapse Admin section',
      links: [
        {
          name: 'View Claims Brokers',
          url: AppRoutes.claimsBroker_List.url(),
          key: AppRoutes.claimsBroker_List.key,
          icon: AppRoutes.claimsBroker_List.icon,
        }, {
          name: 'Add Claims Broker',
          url: AppRoutes.claimsBroker_Create.url(),
          key: AppRoutes.claimsBroker_Create.key,
          icon: AppRoutes.claimsBroker_Create.icon,
        }, {
          name: 'Manage Tariff Codes',
          url: AppRoutes.tariff_code_draft_manage.url(),
          key: AppRoutes.tariff_code_draft_manage.key,
          icon: AppRoutes.tariff_code_draft_manage.icon,
        }, {
          name: 'Tariff Code Versions',
          url: AppRoutes.tariff_code_draft_manage.url(),
          key: 'tcodeversions', //AppRoutes.tariff_code_draft_manage.key,
          icon: 'History', //AppRoutes.tariff_code_draft_manage.icon,
        },
      ],
      isExpanded: true,
    }, {
      name: 'My Organization',
      url: AppRoutes.organization_preparerTeams_ViewMy.url(),
      key: AppRoutes.organization_preparerTeams_ViewMy.key,
      expandAriaLabel: 'Expand My Organization section',
      collapseAriaLabel: 'Collapse My Organization section',
      links: [
        {
          name: 'Manage Claims Preparer Teams',
          url: AppRoutes.organization_preparerTeams_Manage.url(),
          key: AppRoutes.organization_preparerTeams_Manage.key,
          icon: AppRoutes.organization_preparerTeams_Manage.icon,
        },
        {
          name: 'View Claims Preparer Teams',
          url: AppRoutes.organization_preparerTeams_ViewMy.url(),
          key: AppRoutes.organization_preparerTeams_ViewMy.key,
          icon: AppRoutes.organization_preparerTeams_ViewMy.icon,
        },
        {
          name: 'Manage Account Administrators',
          url: AppRoutes.organization_tenantAdmins_Manage.url(),
          key: AppRoutes.organization_tenantAdmins_Manage.key,
          icon: AppRoutes.organization_tenantAdmins_Manage.icon,
        },
        {
          name: 'View Account Administrators',
          url: AppRoutes.organization_tenantAdmins_ViewMy.url(),
          key: AppRoutes.organization_tenantAdmins_ViewMy.key,
          icon: AppRoutes.organization_tenantAdmins_ViewMy.icon,
        },
        {
          name: 'View Clients',
          url: AppRoutes.organization_clients_view.url(),
          key: AppRoutes.organization_clients_view.key,
          icon: AppRoutes.organization_clients_view.icon,
        },
        {
          name: 'Create New Client Account',
          url: AppRoutes.organization_client_create.url(),
          key: AppRoutes.organization_client_create.key,
          icon: AppRoutes.organization_client_create.icon,
        },
      ],
      isExpanded: true,
    }, {
      name: 'Drawback Resources',
      url: AppRoutes.export_records.url(),
      key: AppRoutes.export_records.key,
      expandAriaLabel: 'Expand Drawback Resources section',
      collapseAriaLabel: 'Collapse Drawback Resources section',
      links: [
        {
          name: 'View Export Records',
          url: AppRoutes.export_records.url(),
          key: AppRoutes.export_records.key,
          icon: AppRoutes.export_records.icon,
        },
        {
          name: 'Add / Import Export Records',
          url: AppRoutes.export_record_create.url(),
          key: AppRoutes.export_record_create.key,
          icon: AppRoutes.export_record_create.icon,
        },
      ],
      isExpanded: true,
    },//*/
  ];